import { sanitizeUrl } from '@lumapps/router/utils/sanitizeUrl';
import { and } from '@lumapps/utils/function/predicate/and';
import { or } from '@lumapps/utils/function/predicate/or';
import type { HTMLElementConvertOption } from '@lumapps/wrex/serialization/html/fromHTML/types';
import { matchAttribute, matchNode } from '@lumapps/wrex/serialization/html/fromHTML/utils';

import { IFRAME } from '../../../constants';
import { createIframeElement } from '../../../utils/createIframeElement';

type ElementTypes = typeof IFRAME;

/**
 * Element convert options.
 *
 * Warning: the order of these options does matter!
 */
export const ELEMENTS: { [Element in ElementTypes]: HTMLElementConvertOption<Element> } = {
    [IFRAME]: {
        type: IFRAME,
        test: and(
            matchNode({ tagName: 'iframe' }),
            // src or srcDoc should not be empty
            or(matchAttribute('src', /.*/), matchAttribute('srcDoc', /.*/)),
        ),
        transform: ({ properties }: any) => {
            const { src, title, srcDoc, dataProvider } = properties;

            if (srcDoc) {
                return createIframeElement({ src: { doc: srcDoc }, title: title || '', provider: dataProvider });
            }
            return createIframeElement({ src: sanitizeUrl(src) as string, title, provider: dataProvider });
        },
    },
};
